module.exports = __webpack_public_path__ + "static/media/douyin.021986ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assert/images/douyin.png
// module id = 3827
// module chunks = 1